export const FIVE_PRODUCT_LAUNCH_SLUGS = ["vip", "cagrilintide", "ahk-cu", "pt-141", "melanotan-1"] as const;

const LIVE_FIVE_PRODUCT_SLUGS = FIVE_PRODUCT_LAUNCH_SLUGS;

/**
 * These profiles retain the established concentration calculation internally,
 * but their public UI must use neutral, study-defined amount wording and omit
 * dose ranges, schedules, syringe guidance, titration, and saved protocols.
 */
export const FIVE_PRODUCT_STUDY_CONTEXT_SLUGS = ["cagrilintide", "pt-141", "melanotan-1"] as const;

export function isFiveProductLaunchSlug(slug: string): boolean {
	return (FIVE_PRODUCT_LAUNCH_SLUGS as readonly string[]).includes(slug);
}

export function isFiveProductLaunchLive(slug: string): boolean {
	return (LIVE_FIVE_PRODUCT_SLUGS as readonly string[]).includes(slug);
}

export function isFiveProductStudyContextSlug(slug: string): boolean {
	return (FIVE_PRODUCT_STUDY_CONTEXT_SLUGS as readonly string[]).includes(slug);
}
